import {useTranslation} from "react-i18next";
import {Field} from "redux-form";
import ChipsSelect from "../../../reduxFormComponents/ChipsSelect";
import {TextInput} from "../../../reduxFormComponents/TextInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import withStyles from "@material-ui/core/styles/withStyles";

const StyledIconButton = withStyles({
    root: {
        padding: '0 0 0 5px',
    },
})(IconButton);

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between'
    },
    subProfession: {
        flex: '2',
    },
    duration: {
        flex: '1',
        paddingLeft: theme.spacing(0.5)
    },
    price: {
        flex: '1',
        paddingLeft: theme.spacing(0.5)
    }
}));

const ActivityLine = ({fields, subProfessions}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    return <>
        {fields.map((activity, index) => {
            return <div className={`activity-line ${classes.root}`} key={index}>
                <Field name={`${activity}.subProfession`} component={ChipsSelect} label={t('sub-profession')}
                       options={subProfessions} className={classes.subProfession} required/>
                <Field name={`${activity}.duration`} type={'number'} component={TextInput} label={t('duration')}
                       required
                       className={classes.duration}
                       InputProps={{
                           endAdornment: <InputAdornment position="end">{t('min')}</InputAdornment>,
                       }}/>
                <Field name={`${activity}.price`} component={TextInput} label={t('price')} type={'number'} className={classes.price}
                       required
                       InputProps={{
                           endAdornment: <InputAdornment position="end">$</InputAdornment>,
                       }}/>
                <StyledIconButton color='primary' onClick={() => fields.remove(index)}><DeleteIcon size={'small'}/></StyledIconButton>
            </div>
        })}
        <IconButton color='primary'
                    variant='outlined'
                    aria-label={t('add')}
                    onClick={() => fields.push({})}><AddIcon/></IconButton>

    </>
}

export default ActivityLine;